





























































import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import SignInConsent from 'components/auth/SignInConsent.vue'
import LocaleChange from 'components/LocaleChange.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import SignIn from 'components/auth/SignIn.vue'
import api from 'src/assets/api/gql'
import AttendeeGetResponse from 'src/graphql/attendee/AttendeeGetResponse.gql'
import AttendeeGuestSignupCodeJoin from 'src/graphql/attendee_signup/AttendeeGuestSignupCodeJoin.gql'
import AttendeeSignupCodeJoinSession from 'src/graphql/attendee_signup/AttendeeSignupCodeJoinSession.gql'
import { Session } from 'src/graphql/types'

@Component({
  components: {
    SignInConsent,
    LocaleChange,
    PersonAvatar,
    SignIn
  }
})
export default class AttendeeSessionGuestSignup extends Vue {
  me = store.state.person
  loading = false

  @Prop()
  readonly session!: Session

  async startGuest () {
    const id = this.$q.localStorage.getItem(`session:${this.session.id}:guestId`) as string
    if (id) {
      const { data } = await api.query({
        query: AttendeeGetResponse,
        variables: { id }
      })
      if (data?.attendeeResponse) {
        return this.$emit('start', data.attendeeResponse)
      }
    }
    const { data: { attendeeGuestSignupCodeJoin } } = await api.mutate({
      query: AttendeeGuestSignupCodeJoin,
      variables: { signupCode: this.session.signupCode + 'S' }
    })
    if (attendeeGuestSignupCodeJoin?.sessionAttendee) {
      this.$q.localStorage.set(`session:${this.session.id}:guestId`, attendeeGuestSignupCodeJoin.sessionAttendee.id)
      return this.$emit('start', attendeeGuestSignupCodeJoin.sessionAttendee)
    }
  }

  async startSignIn () {
    const { data: { attendeeSignupCodeJoinSession: { sessionAttendee: attendee} } } = await api.mutate({
      query: AttendeeSignupCodeJoinSession,
      variables: {
        code: this.session.signupCode + 'S'
      }
    })
    if (attendee) {
      this.$router.replace(`/attendee/${attendee.responseSession.topicId}/session/${attendee.responseSession.id}/${attendee.id}`)
    }
  }
}
